import { ILocationSearchRequest } from '../location.types';

export const DEFAULT_SEARCH_REQUEST: ILocationSearchRequest = {
  query: '',
  page: 1,
  sortBy: [],
  filters: [],
};
